import React, { useState, useRef, useEffect } from 'react';
import Draggable from 'react-draggable';
import html2canvas from 'html2canvas';
import './App.css';

function App() {
  const [image, setImage] = useState(null);
  const [originImgWidth, setOriginImgWidth] = useState( 0 );
  const [text, setText] = useState('hello world');
  const [fontSize, setFontSize] = useState(20);
  const [color, setColor] = useState('#FF0000');
  const [textPosition, setTextPosition] = useState({ x: 0, y: 0 });
  const [fontWeight, setFontWeight] = useState(50);
  const [textDraggable, setTextDraggable] = useState( true );
  const captureRef = useRef(null);
  
  // const img = new Image();
  // img.style.display = 'block';

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  // const handleImageInput = (event) => {
  //   const file = event.target.files[0];
  //   console.log( "event.target: ", file.name );
  //   img.src = file.name;// reader.result ? reader.result: 'weiy512.png';
  //   img.onload = () => {
  //     const memeDiv = document.getElementById('memeDiv');
  //     const scaleRate = memeDiv.clientWidth / img.width;
  //     console.log( "scaleRate: ", scaleRate );
  //   }
  // };

  const handleTextChange = (event) => {
    setText(event.target.value);
    console.log( "event.target.value: ", event.target.value );
  };

  const handleFontSizeChange = (event) => {
    setFontSize(event.target.value);
  };

  const handleColorChange = (event) => {
    setColor(event.target.value);
  };

  const handleDragStopped = (event, data) => {
    setTextPosition( { x:data.x, y:data.y } );
    console.log( textPosition );
  };

  const handleFontWightChange = (event) => {
    setFontWeight( event.target.value );
    console.log( "fontWeight: ", fontWeight );
  };

  const handleTextDraggableChange = (event) => {
    setTextDraggable( event.target.checked );
    console.log( textDraggable );
  };

  const saveMeme = () => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.src = image;
    const memeDiv = document.getElementById('memeDiv');

    img.onload = () => {
      const scaleRate = memeDiv.clientWidth / img.width;
      console.log( "scaleRate: ", scaleRate, ", ", memeDiv.clientWidth, ", ", img.width );
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const actualFontSize = parseInt(fontSize/scaleRate);
      ctx.font = `${fontWeight} ${actualFontSize}px Arial`;
      console.log( "actualFontSize: ", actualFontSize, ", fontSize: ", fontSize );
      ctx.fillStyle = color;
      console.log( textPosition );
      ctx.textBaseline = 'top'; // 设置文本基线为顶部, for set position correctly

      // -------- 绘制四个方向的阴影，模拟外轮廓 ------------
      const shadows = [
          {offsetX: 1, offsetY: 1, color: 'black'},
          {offsetX: -1, offsetY: -1, color: 'black'},
          {offsetX: 1, offsetY: -1, color: 'black'},
          {offsetX: -1, offsetY: 1, color: 'black'}
      ];

      shadows.forEach(shadow => {
          ctx.shadowOffsetX = shadow.offsetX;
          ctx.shadowOffsetY = shadow.offsetY;
          ctx.shadowBlur = 2;
          ctx.shadowColor = shadow.color;
          ctx.fillText(text, textPosition.x/scaleRate, textPosition.y/scaleRate);
      });

      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;
      ctx.shadowBlur = 0;
      // --------------- end ----------------

      ctx.fillText(text, textPosition.x/scaleRate, textPosition.y/scaleRate); // 文本位置

      console.log( "text: ", text );
      console.log( "after split: ", text.split('\n') );
      
      const dataURL = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = dataURL;
      link.download = 'meme.png';
      link.click();
    };
  };


  const textStyle = { fontFamily: 'Arial',
                      fontSize: `${fontSize}px`, 
                      color, 
                      fontWeight: `${fontWeight}`,
                      textShadow: '1px 1px 2px black, -1px -1px 2px black, 1px -1px 2px black, -1px 1px 2px black',
                      position: 'absolute',
                      padding: '0px',
                      //border: '2px dotted #ccc',
                      //borderRadius:'4px',
                      backgroundColor: 'rgba(255, 255, 255, 0.05)',
                      //boxDizing: 'border-box',
                      overflow: 'hidden',
                     };
  const imageStyle = { maxWidth: '100%',
                       height: 'auto',
                     };

  return (
    <div className="App">
      <h1>Static Meme Generator</h1><br/><br/>
      <div className="align-left">
        <input type="file" accept="image/*" onChange={handleImageUpload} /><br/>
        
        <label htmlFor="fontSize">Font size:</label> 
        <input id="fontSize" type="number" value={fontSize} onChange={handleFontSizeChange} placeholder="Font size" /><br/>
        
        <label htmlFor="fontWeight">Font weight:</label> 
        <select id="fontWeight" onChange={handleFontWightChange}>
            <option value="500">500</option>
            <option value="700">700</option>
        </select><br/>
        {/* <input id="fontWeight" type="number" value={fontWeight} onChange={handleFontWightChange} placeholder="Font weight" /><br/> */}

        <label htmlFor="color">Font color:</label>
        <input id="color" type="color" value={color} onChange={handleColorChange} /><br/>

        <label htmlFor="dragTextArea">Drag textArea:</label>
        <input type="checkbox" id="dragTextArea" name="dragTextArea" checked={textDraggable} onChange={handleTextDraggableChange}/>
      </div><br/>
      <div className="meme" id="memeDiv" ref={captureRef}>
        <Draggable onStop={handleDragStopped} disabled={!textDraggable} >
          <textarea className="meme-text" 
            style={textStyle}
            onChange={handleTextChange}
            value={text}
          >
          </textarea>            
        </Draggable>
        <img alt="meme" className="meme-image" id="meme-image" style={imageStyle} src={image ? image: 'weiy512.png'} />
      </div>
      <br/><br/><br/>
      <button onClick={saveMeme} className='gradient-button'>Save Meme</button>
    </div>
  );
}

export default App;
